export const getIsAmendFilterSelected = (filtersState, filter) => {
  return filtersState[filter.filterName]
}
